import { createSelector } from 'reselect'
import { AppStateType } from '../reducers'
import { IPublishingLocations } from '../types/publishingLocations'

export const selectPublishingLocations = createSelector(
  [(state: AppStateType) => state.publishingLocations],
  (publishingLocations: IPublishingLocations) =>
    (publishingLocations && publishingLocations.list) || []
)

export const selectPublishingLocationsAsOptions = createSelector(
  [(state: AppStateType) => state.publishingLocations],
  (publishingLocations: IPublishingLocations) =>
    publishingLocations &&
    publishingLocations.list && {
      publishingLocationsList: publishingLocations.list.map(
        ({ name, title }) => ({
          value: name,
          label: title,
        })
      ),
    }
)
